import {useState, useEffect, useRef} from "react";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {FormContainer} from "../../../../palette/Palette";
import Alerts from "../../../../palette/Alerts";
import {useSnackbar} from "notistack";
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    EmailRule
} from 'devextreme-react/form';
import {MakePwd} from "../../../../utils/HelpFunctions";
import format from "date-fns/format";
import axios from "axios";
import {
    ErrorMessage,
    NotiStackInfo
} from "../../../../palette/NotiStackInfo";
import {Button} from "devextreme-react/button";

const date = format(new Date(), 'yyyy-MM-dd');

const users = {
    username: '',
    email: '',
    password: ''
}

const roles = ['Administrador', 'Usuario']

const passwordOptions = {
    mode: 'password',
    disabled: true,
    value: '**********'
};

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}

//const url = 'http://localhost:8083/'
const url = 'https://users-easi4xatjq-uc.a.run.app'

function UserForm(props) {

    const {DataStore, setVisibleForm, setTrigger, trigger, setVisibleGrid} = props;

    const {usersPermissions, companyName, idCompany, imageAsUrl, companyMail, contactNumbers} = DataStore

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess, text: 'Crear usuario'
    })

    const [space, setSpace] = useState(false);
    const [accountResult, setAccountResult] = useState(null)

    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);

    useEffect(() => {
        const {instance} = dxForm.current
        instance.resetValues()
    }, [])

    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        instance.resetValues()
                        setVisibleForm(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electronico contiene espacios en blanco</span>}
            </div>
        )
    }

    const alertsRender = () => {
        return (
            <>
                {accountResult === 'EX' && <Alerts severity={'error'}
                                                   body={'¡Esta cuenta de usuario ya existe!'}/>}
                {accountResult === 'OK' && <Alerts severity={'success'}
                                                   body={'¡Usuario creado exitosamente!'}/>}
            </>
        )
    }

    const onValueChanged = () => {
        const str = users.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true)
        } else {
            setSpace(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const {instance} = dxForm.current
        setSubmitButton({...submitButton, text: 'Creando usuario...', disabled: true})

        let role;
        if (users.role === 'Usuario') {
            role = 'user'
        } else {
            role = 'sroot'
        }

        const password = MakePwd(6)

        const data = {
            companyName, idCompany, contactNumbers, username: users.username, role, companyMail,
            finished: true, permits: usersPermissions, photoURL: imageAsUrl,
            email: users.email, password, date, status: true,
        }

        await axios.post(url, data, {headers: headers})
            .then((res) => {
                if (res.data === 'EX') {
                    instance.resetValues()
                    setSubmitButton({...submitButton, text: 'Crear usuario', disabled: false})
                    setAccountResult('EX')
                    setTimeout(() => setAccountResult(null), 3000)
                }
                if (res.data === 'ERROR') {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                    setSubmitButton({...submitButton, text: 'Crear usuario', disabled: false})
                }
                if (res.data === 'OK') {
                    instance.resetValues()
                    setAccountResult('OK')
                    setTrigger(!trigger)
                    setTimeout(() => {
                        setAccountResult(null)
                        setVisibleForm(false)
                        setVisibleGrid(true)
                    }, 2000)
                    setSubmitButton({...submitButton, text: 'Crear usuario', disabled: false})
                    setTrigger(!trigger)
                }
            }).catch(() => {
                console.log()
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setSubmitButton({...submitButton, text: 'Crear usuario', disabled: false})
            })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="crete-users-container">
                <HeaderPage icon={'fas fa-address-card'} text={'Crear usuario'} load={true}
                            textLoad={''}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            ref={dxForm}
                            formData={users}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="createUsers"
                        >
                            <GroupItem caption="Credenciales" colCount={1} colSpan={1}>
                                <SimpleItem dataField="username" label={{text: 'Nombre o cargo'}}
                                            editorOptions={{maxLength: 70}}>
                                    <RequiredRule message="El nombre de usuario es requerido!"/>
                                </SimpleItem>
                                <SimpleItem dataField="email" label={{text: 'Correo electrónico'}}
                                            editorOptions={{onValueChanged: onValueChanged, maxLength: 70}}>
                                    <EmailRule message="Correo electrónico invalido"/>
                                    <RequiredRule message="Ingrese el Correo electrónico de usuario"/>
                                </SimpleItem>
                                <SimpleItem dataField="password" label={{text: 'Contraseña'}}
                                            editorOptions={passwordOptions}/>
                                <SimpleItem dataField="role" label={{text: 'Rol de usuario'}}
                                            editorType="dxSelectBox"
                                            editorOptions={{
                                                items: roles,
                                                placeholder: 'Seleccionar..'
                                            }}
                                >
                                    <RequiredRule message="Seleccione el rol de usuario"/>
                                </SimpleItem>
                                {accountResult && <SimpleItem render={alertsRender}/>}
                                {space && <SimpleItem render={spaceRender}/>}
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>

                </FormContainer>
            </div>
        </>
    )
}

export default UserForm